var map = {
	"./customer1.png": "6cd2",
	"./customer2.png": "82db",
	"./customer3.png": "ef79",
	"./customer4.png": "55c8",
	"./customer5.png": "d1dd",
	"./customer6.png": "d3f2",
	"./customer7.png": "3bb8",
	"./customer8.png": "eb1e",
	"./customer9.png": "1e1d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4d640";